import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import { accountsTagsStatePrefixPayload, fetchAccountsTags } from "features/Accounts/state/thunks/accountsLabelsThunk";
import { type PayloadAction } from "@reduxjs/toolkit";

const accountsTagsState: FetchingItemsState<string> = {
  items: [],
  itemsCount: 0,
  isLoading: false,
};

const accountsTagsSlice = createFetchingItemsSlice({
  namePayload: accountsTagsStatePrefixPayload,
  initialState: accountsTagsState,
  reducers: {
    setNewTag: (state: FetchingItemsState<string>, action: PayloadAction<string>) => {
      state.items.push(action.payload);
      state.itemsCount += 1;
    },
  },
  thunk: fetchAccountsTags,
});

export const { setNewTag } = accountsTagsSlice.actions;

export default accountsTagsSlice.reducer;
